/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Data_Freshness_TextInputs */

const fr_help_data_freshness_text = /** @type {(inputs: Help_Data_Freshness_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une position peut dater de plusieurs minutes si elle n'est pas rafraîchie à temps par l'opérateur. L'application affiche la date de relevé transmise dans les détails du véhicule.`)
};

const en_help_data_freshness_text = /** @type {(inputs: Help_Data_Freshness_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A position may be several minutes old if it has not been refreshed in time by the operator. The application shows the recorded timestamp sent in the vehicle details.`)
};

/**
* | output |
* | --- |
* | "A position may be several minutes old if it has not been refreshed in time by the operator. The application shows the recorded timestamp sent in the vehicle ..." |
*
* @param {Help_Data_Freshness_TextInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const help_data_freshness_text = /** @type {((inputs?: Help_Data_Freshness_TextInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Data_Freshness_TextInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_data_freshness_text(inputs)
	return en_help_data_freshness_text(inputs)
});